import { render, staticRenderFns } from "./DemoLinksInfo.vue?vue&type=template&id=62ec3872"
import script from "./DemoLinksInfo.vue?vue&type=script&lang=js"
export * from "./DemoLinksInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports